import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';
import { Operation } from '../../../models/operation.model';

@Component({
  standalone: false,
  selector: 'app-active-operations-autocomplete',
  templateUrl: './active-operations-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class ActiveOperationsAutocompleteComponent {
  @Input() sector: string;
  @Input() placeholder: string;
  @Input() includeOperations: string;
  @Input() isSubmitted: boolean;
  items: Array<Operation> = [];
  input: string;
  isListVisible: boolean;
  operationInfo: any;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {
  }

  getAllItems(): any {
    this.getActiveOrders();
  }

  getActiveOrders(): void {
    this.sharedService.getActiveOrders(this.includeOperations, this.sector, this.input).subscribe(
      res => {
        this.items = [];
        res.results.forEach(item => {
          this.items.push(new Operation(item));
        });

        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;

    this.operationInfo = {
      client: item.client,
      name: item.name,
      workOrderName: item.workOrderName,
      workOrderUpisId: item.workOrderUpisId,
      quantity: item.quantity,
      quantityFinishedTotal: item.quantityFinishedTotal,
      timeEstimatedEmployee: item.timeEstimatedEmployee,
      workersCount: item.workersCount,
      timeEstimatedMachine: item.timeEstimatedMachine
    };

    this.isSubmitted = false;

    this.input = `${item.client} - ${this.includeOperations === 'true' ? item.name : item.workOrderName} - ${item.workOrderUpisId}`;

  }

  trackByFn(index): number {
    return index;
  }
}
